import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useOrg } from '../contexts/OrgContext';

export default function Header({ title, backTo, queueCount = 0, syncing = false }) {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const { membership, isAdmin } = useOrg();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <>
      <header className="bg-gray-800 border-b border-gray-700 px-4 py-3 flex items-center justify-between sticky top-0 z-10">
        <div className="flex items-center gap-3 min-w-0">
          {backTo ? (
            <button
              onClick={() => navigate(backTo)}
              className="text-orange-400 hover:text-orange-300 shrink-0 text-sm font-medium"
            >
              ← Back
            </button>
          ) : (
            <Link to="/dashboard" className="text-orange-500 font-bold text-lg shrink-0">
              GroundCheck
            </Link>
          )}
          {title && (
            <h1 className="text-white font-semibold text-base truncate">{title}</h1>
          )}
        </div>

        <div className="flex items-center gap-3 shrink-0">
          {syncing && (
            <span className="text-xs text-orange-400 animate-pulse">Syncing…</span>
          )}
          {!syncing && queueCount > 0 && (
            <span className="text-xs bg-yellow-500/20 text-yellow-400 px-2 py-0.5 rounded-full">
              {queueCount} offline
            </span>
          )}
          {isAdmin && !backTo && (
            <Link to="/admin" className="text-gray-400 hover:text-white text-sm">
              Admin
            </Link>
          )}
          {!backTo && (
            <button
              onClick={handleSignOut}
              className="text-sm text-gray-400 hover:text-white"
            >
              Sign out
            </button>
          )}
        </div>
      </header>
      {membership && (
        <div className="bg-gray-900 border-b border-gray-800 px-4 py-1">
          <span className="text-gray-600 text-xs">{membership.org_name}</span>
        </div>
      )}
    </>
  );
}
